// extracted by mini-css-extract-plugin
export default {"container":"CMSSection_container__E9KX8","header":"CMSSection_header__M34Ov","wrapperCard":"CMSSection_wrapperCard__L7AZh","box":"CMSSection_box__4OtZQ"};